import { Text } from "@sembark-travel/ui/base"
import { ICabType } from "./store"

type IShowCabCapacityInfoProps = {
	cabType: Pick<ICabType, "capacity" | "capacity_child_age_limit">
}

export function ShowCabCapacityInfo({ cabType }: IShowCabCapacityInfoProps) {
	const { capacity, capacity_child_age_limit } = cabType
	return cabType.capacity ? (
		<Text fontSize="sm" color="muted">
			Cap: {capacity} Pax
			{capacity_child_age_limit
				? ` & C.age> ${capacity_child_age_limit}y`
				: null}
		</Text>
	) : null
}
